import React from 'react';
import { PdfRenovadoresBonusCardC2 } from './pdf-renovadores-bonus-card-c2';
import { PdfRenovadoresBonusCardC3 } from './pdf-renovadores-bonus-card-c3';
import { PdfHuchaCardContainer } from '../../../ui/pdf-hucha-card-container';

export const PdfRenovadoresBonusCard: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	return (
		<PdfHuchaCardContainer>
			<PdfRenovadoresBonusCardC2 dineroHucha={dineroHucha} />
			<PdfRenovadoresBonusCardC3 />
		</PdfHuchaCardContainer>
	);
};
